import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dropdown, Link, Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './Header.css';
import { redirectWithClientId, switchField } from '../../utils/url';
import { BASE_FIELDS_URL, BASE_FIELDS_URL_NEW_ARCH } from '../../constants/urls';
import {
  currentFieldSelector,
  accessibleFieldsSelector,
  currentOperationsSelector,
} from '../../selectors/fieldsSelectors';
import { openModal } from '../../actions/modalActions';
import { OPERATION_NOT_ALLOWED } from '../../constants/modal';

export class Header extends Component {
  onClickEditField = () => {
    const { operation, openModal: openModalProp, field, index, operations, isNewArchFieldSelection } = this.props;
    // MultiOperation behavior is being treated like 'all-operations'
    // until REACT-742 is completed.
    // MultiOperation should allow edit of a single operation 
    const baseFieldsUrl = isNewArchFieldSelection ? BASE_FIELDS_URL_NEW_ARCH : BASE_FIELDS_URL;
    if (operation === 'all-operations' || operations.length > 1) {
      openModalProp(index, null, {
        type: OPERATION_NOT_ALLOWED,
        size: 'M',
      });
    } else {
      redirectWithClientId(baseFieldsUrl, {
        'field-id': field.id,
        view: 'editField',
      });
    }
  };

  onSelectField = (fieldName, id) => {
    switchField(id);
  };

  render() {
    const { field, fields } = this.props;
    const options = fields.map((opField) => ({
      value: opField.name,
      id: String(opField.id),
    }));
    return (
      <header className={styles.header}>
        <Dropdown
          options={options}
          placeholder={field.name}
          searchPlaceholder={getMessage('searchFieldPlaceholder')}
          searchable
          selectedId={field.id}
          setValue={this.onSelectField}
          value={field.name}
        />
        <Link
          className={styles.link}
          onClick={this.onClickEditField}
          title={getMessage('editField')}
          data-test-id='edit-field'
        >
          <Icon glyph={Icon.set.EDIT_SHAPE} />
        </Link>
      </header>
    );
  }
}

Header.propTypes = {
  field: PropTypes.object.isRequired,
  fields: PropTypes.array,
  index: PropTypes.number.isRequired,
  isNewArchFieldSelection: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  operation: PropTypes.string,
  operations: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    field: currentFieldSelector(state),
    fields: accessibleFieldsSelector(state),
    operation: state.operations.current,
    operations: currentOperationsSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openModal,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
